import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import DatePicker from '../../bronson/Datepicker';
import Input from '../../bronson/Input';

const ModalfiltrosAsignacionVV = props => {
    const [fechadesde, setFechadesde] = useState('');
    const [fechahasta, setFechahasta] = useState('');
    const [codigofilter, setcodigofilter] = useState('');
    const [nombrefiter, setnombrefiter] = useState('');

    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    }, []);

    const onChangeFilterfechahasta = target => {
        setFechahasta(target);
    };
    const onChangeFilterfechadesde = target => {
        setFechadesde(target);
    };

    const onchangeNombre = target => {
        setnombrefiter(target.target.value);
        if (codigofilter !== '' && target.target.value !== '') {
            setcodigofilter('');
            document.getElementById('idConcesionario').value = '';
        }
    };
    const onchangeCodigo = target => {
        setcodigofilter(target.target.value);
        if (nombrefiter !== '' && target.target.value !== '') {
            setnombrefiter('');
            document.getElementById('NomConcesionario').value = '';
        }
    };

    function setFilterAply() {
        props.onchangeCodigo(codigofilter);
        props.onchangeNombre(nombrefiter);
        props.setFechaDesde(fechadesde);
        props.setFechaHasta(fechahasta);
        props.setModalfiltrosAsignacionVV(false);
    }
    return (
        <div className="c-modal">
            <div
                className="c-modal__overlay js-modal-close"
                onClick={() => props.setModalfiltrosAsignacionVV(false)}
            ></div>
            <div
                className="c-modal__wrapper modalPosition_Asignacion"
                role="dialog"
                aria-labelledby="foo-bar-baz"
                style={{ top: '33%' }}
            >
                <header
                    className="c-modal__header u-p-none"
                    style={{
                        paddingTop: '10px',
                    }}
                >
                    <div className="o-layout__item u-10/12 ">
                        <label className=" c-modal__title">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16.5 21"
                            >
                                <path
                                    id="Shape"
                                    d="M5.25,1.5h1.5V12H5.25Zm0,18h1.5v3H5.25ZM6,18a2.25,2.25,0,1,1,2.25-2.25A2.25,2.25,0,0,1,6,18Zm0-3a.75.75,0,1,0,.75.75A.75.75,0,0,0,6,15ZM17.25,1.5h1.5V12h-1.5Zm0,18h1.5v3h-1.5ZM18,18a2.25,2.25,0,1,1,2.25-2.25A2.307,2.307,0,0,1,18,18Zm0-3a.75.75,0,1,0,.75.75A.709.709,0,0,0,18,15Zm-6.75-3h1.5V22.5h-1.5Zm0-10.5h1.5v3h-1.5Zm.75,9A2.307,2.307,0,0,1,9.75,8.25a2.25,2.25,0,0,1,4.5,0A2.307,2.307,0,0,1,12,10.5Zm0-3a.709.709,0,0,0-.75.75.75.75,0,0,0,1.5,0A.709.709,0,0,0,12,7.5Z"
                                    transform="translate(-3.75 -1.5)"
                                    fill="#004666"
                                    fillRule="evenodd"
                                />
                            </svg>

                            <span className="mideltextfilter u-text-brand">
                                Filtros
                            </span>
                        </label>
                    </div>

                    <div className="o-layout__item u-2/12">
                        <button
                            onClick={() =>
                                props.setModalfiltrosAsignacionVV(false)
                            }
                            className="c-modal__close-btn  js-modal-close"
                            type="button"
                            aria-label="Cerrar modal."
                        />
                    </div>
                </header>
                <div
                    className="c-modal__content u-mt-xsmall u-pb-small"
                    role="document"
                >
                    <div
                        className="input-div u-mb-small"
                        onChange={onchangeCodigo}
                    >
                        <label className="u-text-brand u-text-left mideltextfilter u-1/1">
                            Código Concesionario
                        </label>
                        <Input
                            options={{
                                id: 'idConcesionario',
                                type: 'text',
                                placeHolder: 'Introduce un Cod.Conce',
                                autoComplete: 'off',
                            }}
                            onChange={() => {}}
                        />
                    </div>
                    <div
                        className="input-div u-mb-small"
                        onChange={onchangeNombre}
                    >
                        <label className="u-text-brand u-text-left mideltextfilter u-1/1">
                            Nomnre Concesionario
                        </label>
                        <Input
                            options={{
                                id: 'NomConcesionario',
                                type: 'text',
                                placeHolder: 'Introduce un Nom.Conce',
                                autoComplete: 'off',
                            }}
                            onChange={() => {}}
                        />
                    </div>
                    <div
                        className="input-div u-mb-small"
                        onChange={onchangeNombre}
                    >
                        <label className="u-text-brand u-text-left mideltextfilter u-1/1">
                            Fecha desde
                        </label>
                        <div onChange={onChangeFilterfechahasta}>
                            <DatePicker
                                options={{
                                    id: 'fecha-desde',
                                    type: 'default',
                                }}
                                onChange={onChangeFilterfechahasta}
                            />
                        </div>
                    </div>
                    <div
                        className="input-div u-mb-small"
                        onChange={props.onchangeNombre}
                    >
                        <label className="u-text-brand u-text-left mideltextfilter u-1/1">
                            Fecha Hasta
                        </label>
                        <div onChange={onChangeFilterfechadesde}>
                            <DatePicker
                                options={{
                                    id: 'fecha-hasta',
                                    type: 'default',
                                }}
                                onChange={onChangeFilterfechadesde}
                            />
                        </div>
                    </div>

                    <div className="o-split u-mt-large">
                        <button
                            className="c-btn c-btn--secondary"
                            style={{ width: '45%' }}
                            onClick={() =>
                                props.setModalfiltrosAsignacionVV(false)
                            }
                        >
                            CANCELAR
                        </button>
                        <button
                            className="c-btn"
                            style={{ width: '45%' }}
                            onClick={() => setFilterAply()}
                        >
                            APLICAR FILTROS
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withRouter(ModalfiltrosAsignacionVV);
